<template>
    <span ref="calendar">
    </span>
</template>

<script>
import {createCalendar} from './ouical.js'
export default {
    props: {
        eventId: {
            type: String,
            required: true
        },
        eventTitle: {
            type: String,
            required: true,
        },
        eventStartDate: {
            type: String,
            required: true,
        },
        eventDurationInMinutes: {
            type: String,
        },
        eventEndDate: {
            type: String,
        },
        eventAddress: {
            type: String,
        },
        eventDescription: {
            type: String
        },
        theme: {
            type: String
        }
    },
    data() {
        return {
            calendarElement: null,
        }
    },
    created() {
        let calendarElement = createCalendar({
            options: {
                class: `calendarMenu${ this.theme === 'dark' ? ' calendarMenu_dark' : ''}`
            },
            data: {
                id: this.eventId,
                title: this.eventTitle,
                start: new Date(this.eventStartDate),
                duration: this.eventDurationInMinutes,
                endDate: this.eventEndDate,
                address: this.eventAddress,
                description: this.eventDescription,
            }
        })

        this.calendarElement = calendarElement;
    },
    mounted() {
        this.$refs.calendar.appendChild(this.calendarElement);
    }
}
</script>

<style lang="scss">

</style>


